import { ApiTraveler, ApiFlight, ApiAddress } from '@bhtp-client-api/base';

export class TramsCustomQuote {
    public loginId: string;
    public password: string;
    public providerLoginId: string;
    public providerPassword: string;
    public accountNumber: string;
    public agentCode: string;
    public vendorCode: string;
    public referrer: string;
    public airline: string;
    public hotel: string;
    public carRentalCompany: string;
    public cruiseLine: string;
    public tourOperator: string;
    public rentalCompany: string;
    public departureDate: string;
    public returnDate: string;
    public tripDepositDate: string;
    public tripCost: number;
    public destinationCountry: string;
    public destinationState: string;
    public destinationCity: string;
    public travelers: Array<ApiTraveler>;
    public flights: Array<ApiFlight>;
    public primaryTravelerAddress: ApiAddress;
    public billToAddress: ApiAddress;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/trams-custom-quote.model.ts